import { format } from "date-fns";
import {
  BiTrendingUp,
  BiCalendar,
  BiDollarCircle,
  BiTimeFive,
} from "react-icons/bi";

export const InvestmentCard = ({ investment }) => {
  // Safe date parsing
  const formattedDate = investment.createdAt
    ? format(new Date(investment.createdAt), "MMM dd, yyyy")
    : "N/A";

  return (
    <div className="group relative bg-white/70 backdrop-blur-xl border border-white/60 rounded-2xl p-5 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-lg transition-all duration-300">
      {/* Top Shine */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white to-transparent opacity-60"></div>

      {/* --- Header: Plan Name & Status --- */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center border border-blue-100 shadow-sm">
            <BiTrendingUp size={20} />
          </div>
          <div>
            <h4 className="font-head text-base font-bold text-slate-800 leading-tight">
              {investment.planName || "Investment Plan"}
            </h4>
            <div className="flex items-center gap-1 text-[10px] text-slate-400 mt-0.5 font-medium uppercase tracking-wide">
              <BiTimeFive size={10} /> Active
            </div>
          </div>
        </div>

        {/* Profit Badge */}
        <div className="bg-green-50 text-green-700 px-2.5 py-1 rounded-lg text-[10px] font-bold border border-green-100">
          +{investment.profitProduction || 0}% Yield
        </div>
      </div>

      {/* --- Main Stats Grid --- */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        {/* Amount Invested */}
        <div className="bg-slate-50/50 rounded-xl p-3 border border-slate-100">
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1 flex items-center gap-1">
            <BiDollarCircle /> Invested
          </p>
          <p className="font-head text-slate-800 font-bold text-lg">
            ${investment.amount?.toLocaleString() || "0"}
          </p>
        </div>

        {/* Expected Return (Highlighted) */}
        <div className="bg-blue-50/50 rounded-xl p-3 border border-blue-100 relative overflow-hidden group-hover:bg-blue-50 transition-colors">
          <p className="text-[10px] text-blue-400 font-bold uppercase tracking-wider mb-1 relative z-10 flex items-center gap-1">
            <BiTrendingUp /> Return
          </p>
          <p className="font-head text-blue-700 font-bold text-lg relative z-10">
            ${investment.expectedReturn?.toLocaleString() || "0"}
          </p>
          {/* Subtle decorative blob inside the card */}
          <div className="absolute -bottom-4 -right-4 w-12 h-12 bg-blue-200/50 rounded-full blur-lg"></div>
        </div>
      </div>

      {/* --- Footer: Date & Progress --- */}
      <div className="flex items-center justify-between pt-3 border-t border-slate-100">
        {/* Date */}
        <div className="flex items-center gap-1.5 text-xs text-slate-400 font-body">
          <BiCalendar size={14} className="text-slate-300" />
          <span>
            Ends:{" "}
            <span className="text-slate-600 font-medium">{formattedDate}</span>
          </span>
        </div>

        {/* Progress Visual (Fake visual for Profit Production) */}
        <div className="flex items-center gap-2">
          <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-blue-400 to-green-400 rounded-full"
              style={{
                width: `${Math.min(investment.profitProduction, 100)}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};
